import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

/**
 * Checks whether the HTTP error is handled globally and should not be
 * handled again by individual components.
 *
 * Globally handled errors:
 * - 401 Unauthorized
 * - 403 Forbidden
 * - 404 Not Found
 */
export function isGloballyHandledError(error: HttpErrorResponse): boolean {
    return [
        HttpStatusCode.Unauthorized,
        HttpStatusCode.Forbidden,
        HttpStatusCode.NotFound,
    ].includes(error.status);
}
